
import { Vue, Options } from "vue-class-component";
import { Emit, Model, Prop, Watch } from "vue-property-decorator";
import { ElMessage } from "element-plus";
import MiezzPageList from "@/models/MiezzPageList";
import DtoPageListSearchOrderPoolExpress from "@/models.machine/DtoPageListSearchOrderPoolExpress";
import DtoListItemOrderPoolExpress from "@/models.machine/DtoListItemOrderPoolExpress";
import CurrentLogier from "@/apis/CurrentLogier";
import { MiezzMenuTab } from "@/components/MiezzMenuTab.vue";
import { EnumOrderServiceType } from "@/models.machine/EnumOrderServiceType";
import ExpressPageList from "../../Pool/ExpressPage/ExpressPageList.vue";
@Options({
  components: {
    ExpressPageList,
  },
})
export default class DestinationPortExpressPageList extends Vue {
  menuTab = new MiezzMenuTab();
  list = new MiezzPageList<
    DtoPageListSearchOrderPoolExpress,
    DtoListItemOrderPoolExpress,
    string
  >("OrderManagement_Order_Summary_DestinationPortExpress");
  powers: string[] = [];
  serviceType = EnumOrderServiceType.DestinationPort;

  created(): void {
    CurrentLogier.GetPowerCodes().then((r) => {
      this.powers = r ?? [];
      if (
        this.powers.contains(
          "OrderManagement_Order_Summary_DestinationPortExpress_Delete"
        )
      ) {
        this.list.RowButtons = [
          {
            Code: "delete",
            Title: "删除",
            Icon: "delete",
            Type: "default",
            Size: "small",
            Message: "是否确认删除",
            PowerCode: "OrderManagement_Order_Summary_DestinationPortExpress_Delete",
          },
        ];
      }
    });

    this.menuTab.Back = true;
    this.menuTab.Url = `/order/destination-port-express/${this.$route.params.id}`;
    this.menuTab.Menus = [
      {
        Label: "目的港-快递",
        Url: `/order/destination-port-express/${this.$route.params.id}`,
        Power: "OrderManagement_Order_Summary_DestinationPortExpress",
      },
    ];
  }
}
